<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table #packageListTable (detail)="onDetail($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProviderParams]="params" [dataProvider]="packageService" [title]="'Packages'" [searchColumns]="searchColumns"
                  [searchAll]="true">
  </data-table>

</page-content>
